module.exports = "/images/vendor/desiigner-svg/svg/logos/48-ore-calabria-costa-ionica.svg?d5ec0fcf1d90f18d4ecafdcbabdb868d";